/** Inline result viewer — renders markdown or JSON (FR-SPA-05). */

import { Box, Typography, Paper, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

interface Props {
  content: string | Record<string, unknown>;
  format: string;
  downloadOnly?: boolean;
  onDownload?: () => void;
}

export default function ResultViewer({ content, format, downloadOnly, onDownload }: Props) {
  if (downloadOnly) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography color="text.secondary" gutterBottom>Result too large for inline viewing</Typography>
        {onDownload && <Button variant="contained" startIcon={<DownloadIcon />} onClick={onDownload}>Download Result</Button>}
      </Box>
    );
  }

  if (format === "json") {
    return (
      <Paper variant="outlined" sx={{ p: 2, overflow: "auto", maxHeight: 600 }}>
        <pre style={{ margin: 0, whiteSpace: "pre-wrap", fontSize: 13 }}>
          {typeof content === "string" ? content : JSON.stringify(content, null, 2)}
        </pre>
      </Paper>
    );
  }

  // Markdown (default)
  return (
    <Paper variant="outlined" sx={{ p: 2, overflow: "auto", maxHeight: 600, "& table": { borderCollapse: "collapse", width: "100%" }, "& th, & td": { border: "1px solid", borderColor: "divider", p: 1 } }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
        {typeof content === "string" ? content : JSON.stringify(content)}
      </ReactMarkdown>
    </Paper>
  );
}
